/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 7 hook(s) need dependency review; fix each and remove this directive */
import { useTranslation, untranslated } from "@i18n";
import get from "lodash/get";
import { portalCreateRoot as createRoot } from "@CubeComponents/html/cellPortals";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "@Reducers/index";
import { useState, useEffect, useRef, useCallback, forwardRef, useContext, useMemo } from "react";
import MultiSelectComponent from "@CubeComponents/form/MultiselectComponent";
import { GrClose } from "react-icons/gr";
import ChipListComponent, {
  ChipsDirective,
  ChipDirective,
} from "@CubeComponents/form/ButtonComponent/ChipListComponent";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import CalibrationModal from "./CalibrationModal";
import CreateNewTakeoffModal from "./CreateNewTakeoffModal";
import * as ACTIONS from "@Actions/estimation";
import { setEstimateFieldsNeedtoRefresh, estimateFieldsNeedToRefreshIntialState } from "@Reducers/EstimateList";
import { getViewerUrl } from "@Helpers";
import { estimateMeasurementsUrl } from "@Services/dataManager";
import OpenInViewerIcon from "@Components/StickySidebarViewer/assets/OpenInViewerIcon";
import { setModalStatus, setSelectedNestedMeasurements } from "@Reducers/Viewer";
import ToolTipComponent from "@CubeComponents/html/tooltip";
import { GetEstimateDataProp, getEstimateData } from "@Actions/EstimateList";
import {
  DuplicateTakeoffModal,
  EstimateNotFoundPage,
  ManualMeasurements as ManualMeasurement,
  getMeasurementsListColumns,
} from "@Features/estimation";
import { showToastNotification } from "@Reducers/toastSlice";
import { TOAST_TYPE_ERROR, TOAST_TYPE_NORMAL } from "@Services/constants";
import { getFileversionIdAndNodeOffsetIdMap } from "@Services/cubeViewHelper";
import { folderPermissions } from "@Helpers/constants";
import IconComponent from "@CubeComponents/icons";
import SelectDropDown from "@CubeComponents/Mui_Form/SelectDropDown";
import {
  CubeGlobal,
  HoopsViewerContext,
  getAggregateMeasurementBoundingBox,
  useViewerCallbacks,
} from "@Features/viewer-core";
import { setIsMeasurementStarted } from "@Reducers/measurements";
import { dispatchModelLoadingToast, updateMeasurementAttributePopup } from "@Actions/Viewer";
import { getIsViewerDependencyLoaded } from "@Services/utils/helpers";
import DeriveMeasurements from "./DeriveMeasurements";
import TextFieldComponent from "@CubeComponents/Mui_Form/TextFieldComponent";
import { Box, Tab, Tabs } from "@mui/material";
import SlickGrid1 from "@CubeComponents/html/SlickGrid1";
import Text from "@CubeComponents/html/Text/Text";
import { createUuid, OperatorId, Selection } from "@ts3d-hoops/web-viewer";
import type { EstimateData } from "@ServerTypes/estimates/estimates.schema";
import type { MeasurementItem } from "@ServerTypes/measurements/measurements.schema";
import type { ObjectIdString } from "@Helpers/schemas/common.schema";

const { RESOURCE_VIEW, RESOURCE_MODIFY } = folderPermissions();

type LoadedDisplayUnit = NonNullable<EstimateData["linearDisplayUnit"]> & {
  factor: number;
  selectedSymbol: { name: string };
  type: { name: string };
};

type EstimateDataWithDisplayUnits = EstimateData &
  Record<
    "linearDisplayUnit" | "areaDisplayUnit" | "volumeDisplayUnit" | "countDisplayUnit" | "angleDisplayUnit",
    LoadedDisplayUnit
  >;

type MeasurementUnit = NonNullable<MeasurementItem["unit"]>;

/**
 * A measurement as rendered in the grid: the server `MeasurementItem` with the embeds this
 * component always reads present. The ids are indexed out of the server type so the branded
 * `unit.type.id` / `takeOffs[].takeOffItemId` survive the narrowing.
 */
type MeasurementRow = MeasurementItem & {
  unit: { type: { id: NonNullable<NonNullable<MeasurementUnit["type"]>["id"]> } };
  multiplier?: number;
  nature?: string;
  takeOffs?: NonNullable<MeasurementItem["takeOffs"]>;
};

const TEMP_MARKUP_NAMES = new Set([
  "ThreePointsAngleMarkup",
  "MeasurePointPointDistance",
  "CustomAreaMarkup",
  "QTakeOffPoint3DMarkup",
]);

const MEASUREMENT_TOOLBAR_IDS = {
  START: "start_measurement",
  EDIT: "edit_measurement",
  DELETE: "delete_measurement",
  ADD_TO_TAKEOFFS: "add_to_takeoffs",
  DUPLICATE: "duplicate_measurement",
  DERIVE: "derive_measurement",
  SITE_MEASUREMENT: "site_measurement",
  SAVE: "save_measurement",
  CANCEL: "cancel_measurement",
};

const Measurements = forwardRef(({ openAsPopup = false, ...props }: any, ref) => {
  const { t } = useTranslation();
  const { isModelStructureReady, isSettingsApplied, viewerImpl, showCalibrationModal, handleCalibrationModal }: any =
    useContext(HoopsViewerContext);
  const hwv = viewerImpl?.hwv;

  const {
    showDynamic,
    fileVersionId,
    takeOffItemId,
    estimateId,
    source,
    quantityTakeoffToolbarVisibility,
    takeOffIncludedMeasuremnt,
    setBtnState,
    deleteMeasurementFromTakeOff,
    handleRowSelection,
  } = props;

  // External entry point: route params are raw strings, so the estimate-version id is typed once
  // here, on the hook itself (the backend route schema validates it).
  const params = useParams<{ versionId: ObjectIdString }>();

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [duplicateModalAndData, setDuplicateModalAndData] = useState<any>({
    show: false,
    data: {},
  });
  const [startStop, setStartStop] = useState(false);
  const [itemsMarked, setItemsMarked] = useState<string[]>([]);
  const [takeoffsList, setTakeoffsList] = useState<any[]>([]);
  const [takeoffsChecked, setTakeoffsChecked] = useState<string[]>([]);
  const [showTakeoffsList, setShowTakeoffsList] = useState(false);
  const [allMeasurementTags, setAllMeasurementTags] = useState<any[]>([]);
  const [showNewTakeoffModal, setShowNewTakeoffModal] = useState(false);
  const [enableToolbarButtons, setEnableToolbarButtons] = useState(false);
  const [manualMeasurementModal, setManualMeasurementModal] = useState({
    show: false,
    data: null,
  });
  const [editingRowValue, setEditingRowValue] = useState<any>({});
  const [displayMeasurements, setDisplayMeasurements] = useState<any>({});
  const [selectMeasurementAndPage, setSelectMeasurementAndPage] = useState(false);
  const itemsMarkedRef: any = useRef([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const urlSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const getInitialSheetId = () => {
    let initialSheetId: any = null;
    if (source == ACTIONS.measurementSources.MEASUREMENTS) {
      initialSheetId = -1;
      if (
        getIsViewerDependencyLoaded({ isModelStructureReady, isSettingsApplied, viewerImpl, hwv: CubeGlobal.hwv }) &&
        viewerImpl.hwv.sheetManager.getActiveSheetId()
      ) {
        initialSheetId = viewerImpl.hwv.sheetManager.getActiveSheetId();
      } else if (urlSearchParams.get("measurementId")) {
        initialSheetId = null;
      }
    }
    return initialSheetId;
  };
  const [currentSheetId, setCurrentSheetId] = useState(getInitialSheetId());
  const currentSheetIdRef = useRef(currentSheetId);
  const isInitialMarkupLoadDone = useRef(false);

  const typePerimeterRef = useRef<any>(null);
  const typeSurfaceAreaRef = useRef<any>(null);
  const typeCircumferenceRef = useRef<any>(null);
  const typeLengthSegmentsRef = useRef<any>(null);

  const typePerimeter = { text: "Perimeter", value: "perimeter", reference: typePerimeterRef };
  const typeSurfaceArea = { text: "Surface Area", value: "surfaceArea", reference: typeSurfaceAreaRef };
  const typeCircumference = { text: "Circumference", value: "circumference", reference: typeCircumferenceRef };
  const typeLengthSegments = { text: "Length Segments", value: "lengthSegments", reference: typeLengthSegmentsRef };

  const derivedMeasurementsBaseValue = {
    [typePerimeter.value]: [],
    [typeSurfaceArea.value]: [],
    [typeCircumference.value]: [],
    [typeLengthSegments.value]: [],
  };
  const emptyDerivedMeasurements = {
    data: derivedMeasurementsBaseValue,
    selectedRecords: derivedMeasurementsBaseValue,
  };
  const [derivedMeasurementOptions, setDerivedMeasurementOptions] = useState<any>([]);
  const [activeDerivedMeasurementTab, setActiveDerivedMeasurementTab] = useState<string | null>(null);
  const [showDeriveMeasurementsModal, setShowDeriveMeasurementsModal] = useState(false);
  const [derivedMeasurementSelected, setDerivedMeasurementSelected] = useState(false);
  const flagToCheckRowSelectionRef = useRef(false);

  const HoopsModalStatus = useSelector((state: RootState) => state.HoopsModalStatus);
  const takeoffData = useSelector((state: RootState) => state.takeoffData);
  const isMeasurementStarted = useSelector((state: RootState) => state.isMeasurementStarted);
  const measurementsList = useSelector((state: RootState) => state.measurementsList);
  const measurementsModalStatus = useSelector((state: RootState) => state.measurementsModalStatus);
  const estimateData = useSelector((state: RootState) => state.estimateData);
  const estimateError = useSelector((state: RootState) => state.estimateError);
  const estimateFieldsNeedToRefresh = useSelector((state: RootState) => state.estimateFieldsNeedToRefresh);
  const filesData = useSelector((state: RootState) => state.filesData);
  const fileversionIdAndNodeOffsetIdMap = useSelector((state: RootState) => state.fileversionIdAndNodeOffsetIdMap);

  const actionPermissionAllowed = ACTIONS.isEstimateRequiredPermission(estimateData, RESOURCE_MODIFY.id);

  useEffect(() => {
    if (selectMeasurementAndPage && dataGrid.current && measurementsList.length) {
      const measurementId = urlSearchParams.get("measurementId");
      const index = measurementsList.findIndex((ele: any) => ele.measurementId == measurementId);
      if (index !== -1) {
        dataGrid.current.slickGrid.setSelectedRows([index]);
      }
    }
  }, [selectMeasurementAndPage]);

  const localRef = useRef<any>(null);
  const dataGrid: any = ref || localRef;
  const startStopRef = useRef(startStop);
  const displayMeasurementsRef: any = useRef({});
  const measurementsListRef: any = useRef([]);
  const derivedMeasurementsGrid = useRef<any>(null);
  const takeoffDataRef = useRef(takeoffData);
  const derivedMeasurementsRef: any = useRef(emptyDerivedMeasurements);
  const takeoffsModalStatusRef = useRef(HoopsModalStatus.Takeoffs);
  const measurementsModalStatusRef = useRef(measurementsModalStatus);
  const activeDerivedMeasurementTabRef: any = useRef(activeDerivedMeasurementTab);

  const isFilterAllowed =
    source === ACTIONS.measurementSources.MEASUREMENTS || source === ACTIONS.measurementSources.ESTIMATE;
  // External entry points: the estimate-version id arrives either as the `:versionId` route
  // param or as the `versionId` query param. Both are adopted once here, at their declaration,
  // so every request below can pass them through unasserted (the backend route schema validates).
  const routeVersionId = params.versionId;
  const queryVersionId = urlSearchParams.get("versionId") as ObjectIdString | null;
  const estimateVersionId = routeVersionId || queryVersionId;
  const fileRemovedTooltipContent = t("File from which the measurement was taken is not available.");

  const initialRender = useRef(true);

  const [gridQuery] = useState(
    source == ACTIONS.measurementSources.MEASUREMENTS
      ? null
      : {
          params: {
            estimateId,
            fileVersionId: takeOffIncludedMeasuremnt ? undefined : fileVersionId,
            takeOffItemId,
            versionId: estimateVersionId || undefined,
            showDynamic,
            takeOffIncludedMeasuremnt,
          },
        },
  );

  const activateOperator = function (operatorId: any, opIndex = 1) {
    viewerImpl.activateOperator(operatorId, opIndex);
  };

  const fetchMeasurements = useCallback(async () => {
    const params: any = {
      estimateId,
      takeOffItemId: null,
      fileVersionId,
      versionId: estimateVersionId || undefined,
    };
    if (currentSheetIdRef.current) {
      params.sheetId = currentSheetIdRef.current;
    }
    dispatch(ACTIONS.getMeasurements(params));
  }, [estimateId, fileVersionId, estimateVersionId]);

  useEffect(() => {
    if (estimateData._id) {
      setAllMeasurementTags(estimateData.tags as string[]);
    }
  }, [estimateData.tags, estimateData._id]);

  const loadMarkupStyles = (viewerMarkup: any, data: any) => {
    const { lineThickness, fillOpacity, symbolSize, countSymbol, lineColor: line_color, fillColor: fill_color } = data;
    const lineColor = line_color && ACTIONS.prepareMarkupColor(line_color);
    const fillColor = fill_color && ACTIONS.prepareMarkupColor(fill_color);
    ACTIONS.loadMarkupStylesViewer({
      viewerImpl,
      viewerMarkup,
      lineThickness,
      fillOpacity,
      symbolSize,
      countSymbol,
      lineColor,
      fillColor,
      isModelStructureReady,
      isSettingsApplied,
      hwv,
    });
  };

  const styleMarkups = (measurement: any, getAllMeasurements: any) => {
    if (!measurement.takeOffs?.length) return;
    const viewerMarkup = getAllMeasurements.find((record: any) => record.cubeUniqueId === measurement.measurementId);
    if (!viewerMarkup) return;

    loadMarkupStyles(viewerMarkup, measurement.takeOffs[0]);
  };

  const loadAllMarkups = async () => {
    const markups = measurementsListRef.current
      .filter((record: any) => record.markup !== "{}")
      .map((record: any) => JSON.parse(record.markup));
    const measurementIds = measurementsListRef.current.map((record: any) => record.measurementId);
    const obj: any = {};
    measurementIds.map((record: any) => {
      obj[record] = true;
    });
    setDisplayMeasurements(obj);
    await viewerImpl.loadMarkups(markups);
    const getAllMeasurements = viewerImpl.hwv.measureManager.getAllMeasurements();
    measurementsListRef.current.map((measurement: any) => styleMarkups(measurement, getAllMeasurements));

    const measurement3D = measurementsListRef.current.filter(
      (measurement: any) => measurement.markup == "{}" && measurement.nature !== "Static" && measurement.elements,
    );
    if (measurement3D.length && filesData[fileVersionId]) {
      const mapper = getFileversionIdAndNodeOffsetIdMap(fileVersionId);
      measurement3D.map((measurement: any) => {
        handle3DElementSelectCallback(measurement.elements, mapper);
      });
    }
  };

  const filterMeasurementsForUnmount = (measurementsData: any) => {
    if (takeoffsModalStatusRef.current) {
      if (takeoffsModalStatusRef.current.currentStage === "Takeoffs") {
        measurementsData = measurementsData.filter((record: any) => !record.takeOffs?.length);
      } else if (takeoffsModalStatusRef.current.currentStage === "Takeoff_Detail") {
        measurementsData = measurementsData.filter(
          (record: any) =>
            !record.takeOffs?.find((takeoff: any) => takeoff.takeOffItemId == takeoffDataRef.current.takeOffItemId),
        );
      }
    }
    return measurementsData;
  };

  const removeAllMarkupsFromViewer = ({ unmount = false }: any) => {
    if (getIsViewerDependencyLoaded({ isModelStructureReady, isSettingsApplied, viewerImpl, hwv: CubeGlobal.hwv })) {
      let measurementsData = measurementsListRef.current;
      setDisplayMeasurements(
        measurementsData.reduce((prev: any, curr: any) => {
          prev[curr.measurementId] = false;
          return prev;
        }, {}),
      );
      const getAllMeasurements = viewerImpl.hwv.measureManager.getAllMeasurements();

      if (unmount) measurementsData = filterMeasurementsForUnmount(measurementsData);
      const markupDataIds = new Set(measurementsData.map((record: any) => record.measurementId));
      const markupsToRemove = getAllMeasurements.filter((record: any) => markupDataIds.has(record.cubeUniqueId));
      for (const markup of markupsToRemove) {
        viewerImpl.hwv.measureManager.removeMeasurement(markup);
      }

      const measurement3D = measurementsData.filter(
        (measurement: any) => measurement.markup == "{}" && measurement.nature !== "Static" && measurement.elements,
      );
      if (measurement3D.length && filesData[fileVersionId]) {
        const mapper: any = getFileversionIdAndNodeOffsetIdMap(fileVersionId);
        measurement3D.map((data: any) => {
          const element = data.elements;
          if (viewerImpl.hwv.selectionManager.isNodeSelected(element.nodeId + mapper[element.fileVersionId])) {
            const selectedSelectionItem = viewerImpl.hwv.selectionManager.getResults();
            const selectionItem = selectedSelectionItem.find(
              (item: any) => item.getNodeId() == element.nodeId + mapper[element.fileVersionId],
            );
            selectionItem && viewerImpl.hwv.selectionManager.remove(selectionItem);
          }
        });
      }
    }
  };

  const reloadMeasurements = (fetchData: any) => {
    if (source === ACTIONS.measurementSources.MEASUREMENTS && fetchData) fetchMeasurements();
    else if (source === ACTIONS.measurementSources.TAKEOFFS) {
      dispatch(
        ACTIONS.getTakeoffData({
          takeOffItemId,
          estimateId,
          versionId: queryVersionId ?? undefined,
        }),
      );
      dataGrid.current.refresh();
    }
  };

  const saveMeasurements = async (measurement: any, fetchData: any) => {
    const { cubeUniqueId, _name, _measurementValue, calScale, _unitMultiplier } = measurement;
    const measurementDetails = ACTIONS.getMeasurementDetails(_name);
    if (!measurementDetails.type) return;

    let nestedMeasurements = measurement.getNestedMeasurements ? measurement.getNestedMeasurements() : null;

    nestedMeasurements = nestedMeasurements
      ? nestedMeasurements.map((record: any, index: number) => ({
          type: record.type.value,
          originalValue: record.value,
          alteredValue: record.value,
          name: record.name === "" ? `Measurement ${index + 1}` : record.name,
        }))
      : null;

    nestedMeasurements = nestedMeasurements
      ? JSON.stringify({
          data: nestedMeasurements,
          total: {
            originalValue: _measurementValue * _unitMultiplier,
            alteredValue: _measurementValue * _unitMultiplier,
            name: "Measurement",
            type: measurementDetails.type,
          },
        })
      : null;

    const scale = calScale ? `1:${Number.parseFloat(Number.parseFloat(calScale).toFixed(3))}` : "1:1";

    const markupData = {
      measurementId: cubeUniqueId,
      name: measurementDetails.name,
      type: measurementDetails.type,
      quantity: _measurementValue * _unitMultiplier,
      nestedMeasurements,
      takeOffItemId,
      scale,
      markup: JSON.stringify(measurement.toJson()),
      fileVersionId,
      estimateId,
      sheetId: currentSheetIdRef.current,
    };

    await ACTIONS.createMeasurement(markupData);
    reloadMeasurements(fetchData);
  };

  const destroyMeasurement = async () => {
    const selectedData = dataGrid.current.slickGrid
      .getSelectedRows()
      .map((data: any) => dataGrid.current.slickGrid.getDataItem(data));
    if (source === ACTIONS.measurementSources.TAKEOFFS) {
      const response = await deleteMeasurementFromTakeOff({
        measurementIds: selectedData.map((item: any) => item.measurementId),
      });
      if (response && get(dataGrid, "current")) {
        dataGrid.current.refresh();
      }
    } else {
      if (!itemsMarked.length) return;

      const data = { key: itemsMarked, estimateId };
      const response = await ACTIONS.deleteMeasurement(data);
      if (response.data.status) {
        for (const measurementId of itemsMarked) {
          const measurement = getMeasurementFromId(measurementId);
          measurement && viewerImpl.hwv.measureManager.removeMeasurement(measurement);
        }

        if (get(dataGrid, "current")) {
          dataGrid.current.slickGrid.setSelectedRows([]);
          setItemsMarked([]);
          setEnableToolbarButtons(false);
          reloadMeasurements(true);
          setDisplayMeasurements((prev: any) => {
            const copyObj = { ...prev };
            for (const id of itemsMarked) {
              delete copyObj[id];
            }
            return copyObj;
          });
        }
      }

      const allTakeoffIds = selectedData
        .filter((item: any) => item.takeOffs?.length)
        .flatMap((item: any) => item.takeOffs.map((takeoff: any) => takeoff.takeOffItemId));
      if (allTakeoffIds.length) {
        const setData = ACTIONS.prepareEstimationFieldNeedToRefresh({
          HoopsModalStatus,
          takeoffs: allTakeoffIds,
          estimateFieldsNeedToRefresh,
        });
        dispatch(setEstimateFieldsNeedtoRefresh(setData));
      }
    }
  };

  const showAllTools = () =>
    props.handleToolsVisibility({
      linear: true,
      area: true,
      volume: true,
      count: true,
    });

  const hideAllTools = () =>
    props.handleToolsVisibility({
      linear: false,
      area: false,
      volume: false,
      count: false,
    });

  const showSpecificTool = () => {
    const toolsState: any = {
      linear: false,
      area: false,
      volume: false,
      count: false,
    };
    toolsState[props.takeoffType.toLowerCase()] = true;
    props.handleToolsVisibility(toolsState);
  };

  const startStopMeasurement = () => {
    const currentState = startStop;
    if (!currentState && !isMeasurementStarted.status) {
      setStartStop(!startStop);
      dispatch(setIsMeasurementStarted({ status: true }));
      props.quantityTakeoffToolbarVisibility(true);
      if (takeOffItemId) {
        showSpecificTool();
      } else {
        showAllTools();
      }
      return;
    }

    if (currentState && isMeasurementStarted.status) {
      setStartStop(!startStop);
      props.quantityTakeoffToolbarVisibility(false);
      activateOperator(OperatorId.Select);
      dispatch(setIsMeasurementStarted({ status: false }));
      hideAllTools();
    }
  };

  const headerEyeIconClickHandler = (e: any) => {
    if (getIsViewerDependencyLoaded({ isModelStructureReady, isSettingsApplied, viewerImpl, hwv: CubeGlobal.hwv })) {
      const numberOfMeasurements = measurementsListRef.current.length;
      const numberOfVisibleMeasurements = Object.values(displayMeasurements).filter(Boolean).length;

      if (!numberOfMeasurements) return;
      removeAllMarkupsFromViewer({ unmount: false });
      if (numberOfMeasurements !== numberOfVisibleMeasurements) loadAllMarkups();

      e.stopPropagation();
      e.preventDefault();
    } else {
      dispatch(dispatchModelLoadingToast());
    }
  };

  const finishDeriveMeasurements = () => {
    setActiveDerivedMeasurementTab(null);
    setDerivedMeasurementSelected(false);
    setShowDeriveMeasurementsModal(false);

    derivedMeasurementsGrid.current = null;
    activeDerivedMeasurementTabRef.current = null;
    derivedMeasurementsRef.current = emptyDerivedMeasurements;
  };

  const saveDerivedMeasurements = async (e: any) => {
    e.preventDefault();

    const allDerivedMeasurements = Object.values(derivedMeasurementsRef.current.selectedRecords).flat();
    for (let i = 0; i < allDerivedMeasurements.length; i++) {
      const derivedMeasurement = allDerivedMeasurements[i];
      const fetchData = i === allDerivedMeasurements.length - 1;

      viewerImpl.hwv.measureManager.addMeasurement(derivedMeasurement);
      viewerImpl.hwv.measureManager.finalizeMeasurement(derivedMeasurement);

      await handleSaveMeasurement(derivedMeasurement, fetchData);
    }

    setDerivedMeasurementOptions([]);
    finishDeriveMeasurements();
  };

  const generateDriveMeasurementData = (deriveMeasurement: any) => {
    if (!Array.isArray(deriveMeasurement)) deriveMeasurement = [deriveMeasurement];
    for (let i = 0; i < deriveMeasurement.length; i++) {
      deriveMeasurement[i].id = i;
    }
    return deriveMeasurement;
  };

  const beginDeriveMeasurements = () => {
    let perimeter: any = [];
    let surfaceArea: any = [];
    let circumference: any = [];
    let lengthSegments: any = [];

    const measurement = getMeasurementFromId(itemsMarked[0]);

    // 3d case
    if (measurement) {
      if (measurement.derivePerimeterMeasurement) {
        perimeter = measurement.derivePerimeterMeasurement();
        perimeter = generateDriveMeasurementData(perimeter);
      }
      if (measurement.deriveSurfaceAreaMeasurement) {
        surfaceArea = measurement.deriveSurfaceAreaMeasurement();
        surfaceArea = generateDriveMeasurementData(surfaceArea);
      }
      if (measurement.deriveCircumferenceMeasurement) {
        circumference = measurement.deriveCircumferenceMeasurement();
        circumference = generateDriveMeasurementData(circumference);
      }
      if (measurement.deriveLengthSegmentsMeasurement) {
        lengthSegments = measurement.deriveLengthSegmentsMeasurement();
        lengthSegments = generateDriveMeasurementData(lengthSegments);
      }
    }

    setShowDeriveMeasurementsModal(true);
    setActiveDerivedMeasurementTab(derivedMeasurementOptions[0].value);
    activeDerivedMeasurementTabRef.current = derivedMeasurementOptions[0].value;
    derivedMeasurementsRef.current.data = {
      lengthSegments,
      circumference,
      perimeter,
      surfaceArea,
    };
  };

  const duplicateMeasurementClickHandler = () => {
    const seletedRecord = dataGrid.current.slickGrid
      .getSelectedRows()
      .map((data: any) => dataGrid.current.slickGrid.getDataItem(data));
    setDuplicateModalAndData({ show: true, data: seletedRecord[0] });
  };
  const closeDuplicateMeasurementModal = () => {
    setDuplicateModalAndData({ show: false, data: {} });
  };

  const copyMeasurement = async (linkTakeoffs: any) => {
    const data = {
      measurementId: duplicateModalAndData.data.measurementId,
      estimateId,
      linkTakeoffs,
    };
    const response = await ACTIONS.duplicateMeasurement(data);
    if (response.data.status) {
      if (
        source === ACTIONS.measurementSources.MEASUREMENTS &&
        duplicateModalAndData.data.takeOffs?.length &&
        linkTakeoffs
      ) {
        const setData = ACTIONS.prepareEstimationFieldNeedToRefresh({
          HoopsModalStatus,
          takeoffs: duplicateModalAndData.data.takeOffs.map((takeoff: any) => takeoff.takeOffItemId),
          estimateFieldsNeedToRefresh,
        });
        dispatch(setEstimateFieldsNeedtoRefresh(setData));
      }
      fetchMeasurements();
      closeDuplicateMeasurementModal();
    } else {
      dispatch(
        showToastNotification({
          content: untranslated(response.data.errorMessage ?? "An error occurred"),
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
  };

  const handleTagsChange = async (args: any, measurementId: any) => {
    await ACTIONS.updateMeasurementTags({
      measurementId,
      tags: args.value,
      estimateId,
    });

    const elements = structuredClone(measurementsListRef.current);
    const measurementsUpdated = elements.map((record: any) => {
      const { tags } = record;

      if (record.measurementId === measurementId) {
        if (tags) {
          record.tags = [...record.tags, args.value.at(-1)];
        } else {
          record.tags = args.value;
        }
      }

      return record;
    });
    measurementsListRef.current = elements;

    dispatch(ACTIONS.setMeasurements(measurementsUpdated));
    const getEstimateParams: GetEstimateDataProp = { estimateId };
    if (estimateVersionId) {
      getEstimateParams.versionId = estimateVersionId;
    }
    dispatch(getEstimateData(getEstimateParams));
  };

  const handleShowTakeoffsList = (value: any) => setShowTakeoffsList(value);

  const closeTakeoffModal = () => setShowNewTakeoffModal(false);

  const addToTakeoffsClickHandler = () => {
    const currentState = showTakeoffsList;
    handleShowTakeoffsList(!showTakeoffsList);
    setTakeoffsChecked([]);
    if (!currentState) fetchTakeoffsList();
  };

  const attachMeasurementsToTakeoffs = async () => {
    if (!takeoffsChecked.length) {
      return;
    }

    const data = takeoffsChecked.map((takeoffChecked: any) => ({
      takeOffItemId: takeoffChecked,
      measurementIds: itemsMarked,
    }));
    await ACTIONS.addMeasurementsToTakeoffs({ data, estimateId });
    const setData = ACTIONS.prepareEstimationFieldNeedToRefresh({
      HoopsModalStatus,
      takeoffs: takeoffsChecked,
      estimateFieldsNeedToRefresh,
    });
    dispatch(setEstimateFieldsNeedtoRefresh(setData));

    setShowTakeoffsList(false);
    fetchMeasurements();
  };

  const checkboxClicked = (event: any) => {
    const takeoffCheckedItemId = event.target.name;
    const checkedStatus = event.target.checked;
    if (checkedStatus) setTakeoffsChecked((previous: any) => [...previous, takeoffCheckedItemId]);
    else setTakeoffsChecked((previous: any) => previous.filter((element: any) => element !== takeoffCheckedItemId));
  };

  const fetchTakeoffsList = async () => {
    const versionId = source == ACTIONS.measurementSources.MEASUREMENTS ? queryVersionId : routeVersionId;
    const markedMeasurement = measurementsList.find(
      (val: any) => val.measurementId === itemsMarked[0],
    ) as MeasurementRow;
    const response = await ACTIONS.getTakeoffsList({
      estimateId,
      type: markedMeasurement.unit.type.id,
      versionId: versionId ?? undefined,
    });
    if (response.data.status) setTakeoffsList(response.data.result ?? []);
  };

  const startNewTakeoff = () => {
    setShowNewTakeoffModal(true);
    setShowTakeoffsList(false);
    setTakeoffsChecked([]);
  };

  const handle3DElementSelectCallback = (element: any, mapper: any) => {
    try {
      const selectedNode = Selection.SelectionItem.create(element.nodeId + mapper[element.fileVersionId]);
      viewerImpl.hwv.selectionManager.add(selectedNode, false); // false so that selection callback can be triggered and metadata can be viewed
    } catch (e) {
      console.log(e);
      Promise.reject(e);
    }
  };

  const focusMeasurements = async (measurements: any, mapper: any) => {
    const measurements3D = measurements.filter(
      (data: any) =>
        displayMeasurementsRef.current[data.measurementId] &&
        data.markup == "{}" &&
        data.nature !== "Static" &&
        data.elements,
    );
    const markUpMeasurements = measurements
      .filter((data: any) => data.markup !== "{}")
      .map((measurement: any) => getMeasurementFromId(measurement.measurementId))
      .filter(Boolean);

    const bounding: any = getAggregateMeasurementBoundingBox({
      measurements: markUpMeasurements,
    });

    const nodeIds = measurements3D.map((data: any) => {
      const element = data.elements;
      return element.nodeId + mapper[element.fileVersionId];
    });

    let parentBox;
    if (markUpMeasurements.length && bounding) {
      parentBox = bounding.copy();
    }

    if (nodeIds.length) {
      const dynM = await viewerImpl.hwv.model.getNodesBounding(nodeIds);
      if (parentBox) {
        parentBox.addBox(dynM);
      } else {
        parentBox = dynM.copy();
      }
    }

    if (parentBox) {
      viewerImpl.hwv.view.fitBounding(parentBox, 300);
    }
  };

  const buttonStateHandler = (totalRowsSelected: number) => {
    if (totalRowsSelected >= 1) {
      setEnableToolbarButtons(true);
    } else {
      setEnableToolbarButtons(false);
      setShowTakeoffsList(false);
    }
  };

  const selectingEventsInViewer = async () => {
    const selectedRecords = dataGrid.current.dataView
      .getAllSelectedItems()
      .filter(Boolean)
      .filter((record: any) => !record.__isDummy);
    buttonStateHandler(selectedRecords.length);

    if (source == ACTIONS.measurementSources.TAKEOFFS) return;

    if (!getIsViewerDependencyLoaded({ isModelStructureReady, isSettingsApplied, viewerImpl, hwv: CubeGlobal.hwv }))
      return;
    const needToSelectRecords = selectedRecords.filter(
      (record: any) => !itemsMarkedRef.current.includes(record.measurementId),
    );
    const needToDeselectRecords = itemsMarkedRef.current
      .filter((id: any) => !selectedRecords.some((item: any) => item.measurementId == id))
      .map((id: any) => measurementsListRef.current.find((item: any) => item.measurementId == id));
    if (!needToSelectRecords.length && !needToDeselectRecords.length) {
      return;
    }

    const dataList = needToSelectRecords.length ? needToSelectRecords : needToDeselectRecords;
    const mapper = getFileversionIdAndNodeOffsetIdMap(fileVersionId);
    const measurements: any = [];

    for (const sel of dataList) {
      if (sel.markup !== "{}") {
        measurements.push(getMeasurementFromId(sel.measurementId));
      }
    }

    if (needToSelectRecords.length) {
      dataList
        .filter(
          (element: any) =>
            displayMeasurementsRef.current[element.measurementId] &&
            element.markup == "{}" &&
            element.nature !== "Static" &&
            element.elements,
        )
        .map((element: any) => handle3DElementSelectCallback(element.elements, mapper));
      focusMeasurements(dataList, mapper);
    } else if (needToDeselectRecords.length) {
      if (measurements.length) {
        for (const measurement of measurements) {
          measurement?.unSelect();
        }
        viewerImpl.hwv.markupManager.refreshMarkup(viewerImpl.hwv.view);
      }
    }

    setItemsMarked(selectedRecords.map((record: any) => record.measurementId));
  };

  const selectingEvents = () => {
    switch (source) {
      case ACTIONS.measurementSources.MEASUREMENTS:
        if (!openAsPopup) {
          selectingEventsInViewer();
        }
        break;
      case ACTIONS.measurementSources.TAKEOFFS:
        if (takeOffIncludedMeasuremnt && !takeoffData.isSystemGenerated) {
          selectingEventsInViewer();
        } else {
          if (setBtnState) {
            const selectedRecords = dataGrid.current.dataView
              .getAllSelectedItems()
              .filter((record: any) => record && !record.__isDummy);
            setBtnState(selectedRecords.length > 0);
          }
        }
        break;

      case ACTIONS.measurementSources.REFERENCE_MEASUREMENT:
        handleRowSelection();
        break;
      default:
        break;
    }
  };

  const derivedMeasurementsSelectingEvents = (selectedRecords: any) => {
    if (flagToCheckRowSelectionRef.current) {
      flagToCheckRowSelectionRef.current = false;
    } else {
      derivedMeasurementsRef.current.selectedRecords = {
        ...derivedMeasurementsRef.current.selectedRecords,
        [activeDerivedMeasurementTabRef.current]: selectedRecords,
      };
      setDerivedMeasurementSelected(Object.values(derivedMeasurementsRef.current.selectedRecords).flat().length > 0);
    }
  };

  const selectMeasurement = (measurement: any) => {
    if (measurement.markup !== "{}") {
      viewerImpl.loadMarkups([JSON.parse(measurement.markup)]);
      const getAllMeasurements = viewerImpl.hwv.measureManager.getAllMeasurements();
      const viewerMarkup = getAllMeasurements.find((record: any) => record.cubeUniqueId === measurement.measurementId);
      if (viewerMarkup && measurement.takeOffs?.length) loadMarkupStyles(viewerMarkup, measurement.takeOffs[0]);
    } else if (
      measurement.markup == "{}" &&
      measurement.nature != "Static" &&
      measurement.elements &&
      Object.hasOwn(fileversionIdAndNodeOffsetIdMap, fileVersionId)
    ) {
      handle3DElementSelectCallback(measurement.elements, fileversionIdAndNodeOffsetIdMap);
    }
  };

  const deSelectMeasurement = (measurement: any) => {
    if (measurement.markup !== "{}") {
      const getAllMeasurements = viewerImpl.hwv.measureManager.getAllMeasurements();
      const markupsToRemove = getAllMeasurements.filter(
        (record: any) => record.cubeUniqueId === measurement.measurementId,
      );
      for (const markup of markupsToRemove) {
        viewerImpl.hwv.measureManager.removeMeasurement(markup);
      }
    } else if (
      measurement.markup == "{}" &&
      measurement.nature != "Static" &&
      measurement.elements &&
      Object.hasOwn(fileversionIdAndNodeOffsetIdMap, fileVersionId)
    ) {
      const element = measurement.elements;
      if (
        viewerImpl.hwv.selectionManager.isNodeSelected(
          element.nodeId + fileversionIdAndNodeOffsetIdMap[element.fileVersionId],
        )
      ) {
        const selectedSelectionItem = viewerImpl.hwv.selectionManager.getResults();
        const selectionItem = selectedSelectionItem.find(
          (item: any) => item.getNodeId() == element.nodeId + fileversionIdAndNodeOffsetIdMap[element.fileVersionId],
        );
        selectionItem && viewerImpl.hwv.selectionManager.remove(selectionItem);
      }
    }
  };

  const eyeIconClickHandler = (params: any) => {
    if (getIsViewerDependencyLoaded({ isModelStructureReady, isSettingsApplied, viewerImpl, hwv: CubeGlobal.hwv })) {
      const { measurementId: rowId } = params;
      const currentlyShown = displayMeasurementsRef.current[rowId] ? displayMeasurementsRef.current[rowId] : false;

      if (currentlyShown) {
        setDisplayMeasurements((prev: any) => ({
          ...prev,
          [rowId]: false,
        }));
        deSelectMeasurement(params);
      } else {
        setDisplayMeasurements((prev: any) => ({
          ...prev,
          [rowId]: true,
        }));
        selectMeasurement(params);
      }
    } else {
      dispatch(dispatchModelLoadingToast());
    }
  };

  const recordClickInEstimateTab = (args: any) => {
    if (args.detail.args.cell !== 0) return;
    const rowData = dataGrid.current.slickGrid.getDataItem(args.detail.args.row);
    const isParentFileActive = rowData.isParentFileActive;
    if (isParentFileActive) {
      const object: any = {
        fileVersionId: rowData.fileVersionId,
        estimateId,
        versionId: estimateVersionId,
        measurementId: rowData.measurementId,
        spaceId: estimateData.space?._id,
        projectId: rowData.projectId,
      };

      const viewerUrl = getViewerUrl(object);
      if (viewerUrl) {
        navigate(viewerUrl);
      }
    }
  };

  const recordClick = (params: any) => {
    if (source == ACTIONS.measurementSources.ESTIMATE) {
      recordClickInEstimateTab(params);
    }
  };

  const dataBound = () => {
    if (
      initialRender.current &&
      urlSearchParams.get("measurementId") &&
      source === ACTIONS.measurementSources.MEASUREMENTS &&
      get(dataGrid, "current") &&
      measurementsList.length
    ) {
      initialRender.current = false;
      setSelectMeasurementAndPage(true);
    }
  };

  const handleManualMeasurementEdit = (rowData: any) => {
    handleAddCustomMeasurement({
      name: rowData.name,
      type: rowData.unit.type.name,
      value: ACTIONS.getDisplayQuantity({
        quantity: rowData.quantity,
        factor: rowData.unit.factor,
      }).quantity,
      unit: rowData.formula ? rowData.manualUnit : rowData.unit.id,
      isReferenced: !!rowData.referenceMeasurements?.length,
      references: rowData.referenceMeasurements,
      formula: rowData.formula,
      measurementId: rowData.measurementId,
      takeOffs: rowData.takeOffs,
    });
  };

  const tagsTemplate = (data: any, value: any, a: any, b: any, args: any) => {
    const container = document.createElement("div");
    if (!args.__isDummy) {
      const tags = get(args, "tags.length") ? args.tags : [];

      container.classList.add("w-full");
      const root = createRoot(container);
      root.render(
        <MultiSelectComponent
          disabled={
            estimateVersionId ||
            editingRowValue.measurementId ||
            !actionPermissionAllowed ||
            ![ACTIONS.measurementSources.ESTIMATE, ACTIONS.measurementSources.MEASUREMENTS].includes(source)
          }
          dataSource={allMeasurementTags}
          value={tags}
          mode="Box"
          placeholder={t("Add a Tag")}
          allowCustomValue
          change={(params) => handleTagsChange(params, args.measurementId)}
          changeOnBlur={false}
        />,
      );
    }
    return container;
  };

  const measurementTemplate = (data: any, val: any, a: any, b: any, params: any) => {
    let result: any = "";
    if (!params.__isDummy) {
      const value = ACTIONS.getDisplayQuantity({
        quantity: params.quantity * params.multiplier,
        factor: params.unit.factor,
      }).quantity;
      result = ACTIONS.getEstimateNumberValueBasedOnSettings(value, estimateData, "measurement");
    }
    return result;
  };

  const unitsTemplate = (data: any, value: any, a: any, b: any, params: any) => get(params, "unit.name", "");

  const takeOffsTemplate = (data: any, value: any, a: any, b: any, params: any) => {
    if (!params.__isDummy && get(params, "takeOffs.length")) {
      const data = params.takeOffs.map((takeOff: any) => takeOff.name);
      return data.join(",");
    }
    return "";
  };

  const nameTemplate = (data: any, value: any, a: any, b: any, params: any) => {
    const container = document.createElement("div");
    if (!params.__isDummy) {
      container.classList.add("w-full");
      const root = createRoot(container);
      root.render(
        <div className="flex items-center justify-between w-full gap-1">
          <span className="">{params.name}</span>
          {params.isSystemGenerated && (
            <IconComponent
              name="AutoGenerated"
              position="bottom"
              toolTipContent={t("System-generated via Model to Takeoff Wizard")}
              width="1.25rem"
              height="1.25rem"
            />
          )}
        </div>,
      );
    }

    return container;
  };

  const measuredValueTemplate = (data: any, val: any, a: any, b: any, params: any) => {
    const container = document.createElement("div");
    if (!params.__isDummy) {
      const root = createRoot(container);
      const value = ACTIONS.getDisplayQuantity({
        quantity: params.quantity,
        factor: params.unit.factor,
      }).quantity;

      root.render(<div>{ACTIONS.getEstimateNumberValueBasedOnSettings(value, estimateData, "measurement")}</div>);
    }
    return container;
  };

  const eyeIconTemplate = (data: any, value: any, a: any, b: any, params: any) => {
    const container = document.createElement("div");
    if (!params.__isDummy) {
      const root = createRoot(container);
      if (getIsViewerDependencyLoaded({ isModelStructureReady, isSettingsApplied, viewerImpl, hwv: CubeGlobal.hwv })) {
        let icon;
        if (displayMeasurements[params.measurementId]) {
          icon = "EyeVisible";
        } else {
          icon = "EyeNotVisible";
        }
        root.render(
          <IconComponent name={icon} onClick={() => eyeIconClickHandler(params)} width="1.5rem" height="1.5rem" />,
        );
      }
    }
    return container;
  };

  const hightlightMeasurementTemplate = (data: any, value: any, a: any, b: any, params: any) => {
    const container = document.createElement("div");
    if (!params.__isDummy) {
      const isParentFileActive = params.isParentFileActive;
      const root = createRoot(container);
      if (isParentFileActive) {
        root.render(<OpenInViewerIcon onClick={() => {}} />);
      } else {
        root.render(
          <IconComponent
            color="#e75555"
            showGradient
            name="details"
            toolTipContent={fileRemovedTooltipContent}
            position="bottom"
            width="1.5rem"
            height="1.5rem"
          />,
        );
      }
    }
    return container;
  };

  const eyeIconHeaderTemplate = () => {
    const container = document.createElement("div");
    const root = createRoot(container);

    if (getIsViewerDependencyLoaded({ isModelStructureReady, isSettingsApplied, viewerImpl, hwv: CubeGlobal.hwv })) {
      let icon: string;
      const totalVisibleMeasurements = Object.values(displayMeasurements).filter(Boolean).length;
      if (measurementsListRef.current.length === totalVisibleMeasurements) {
        icon = "EyeVisible";
      } else if (totalVisibleMeasurements) {
        icon = "EyePartialOpen";
      } else {
        icon = "EyeNotVisible";
      }

      root.render(<IconComponent name={icon} onClick={headerEyeIconClickHandler} width="1.5rem" height="1.5rem" />);
    }

    return container;
  };

  const nestedMeasurementTemplate = (data: any, value: any, a: any, b: any, args: any) => {
    const container = document.createElement("div");
    if (!args.__isDummy) {
      container.classList.add("flex");
      const root = createRoot(container);

      const { linearDisplayUnit, areaDisplayUnit, volumeDisplayUnit, countDisplayUnit, angleDisplayUnit } =
        estimateData as EstimateDataWithDisplayUnits;
      let nestedMeasurements = JSON.parse(args.nestedMeasurements);

      if (source === ACTIONS.measurementSources.MEASUREMENTS && !nestedMeasurements) {
        nestedMeasurements = {
          data: getNestedMeasurements(args.measurementId).map((measurement: any, index: number) => ({
            originalValue: measurement.value,
            alteredValue: measurement.value,
            type: measurement.type.value,
            name: measurement.name === "" ? `Measurement ${index + 1}` : measurement.name,
          })),
          total: {
            originalValue: args.quantity * args.multiplier,
            alteredValue: args.quantity * args.multiplier,
            type: args.type,
            name: "Measurement",
          },
        };
      }

      if (get(nestedMeasurements, "data.length")) {
        root.render(
          <ChipListComponent>
            <ChipsDirective>
              {nestedMeasurements.data.map((nestedMeasurement: any, index: number) => {
                const { name, type, alteredValue } = nestedMeasurement;
                let selectedSymbol = "";
                let factor = 1;

                if (linearDisplayUnit.type.name === type) {
                  factor = linearDisplayUnit.factor;
                  selectedSymbol = linearDisplayUnit.selectedSymbol.name;
                }

                if (areaDisplayUnit.type.name === type) {
                  factor = areaDisplayUnit.factor;
                  selectedSymbol = areaDisplayUnit.selectedSymbol.name;
                }

                if (volumeDisplayUnit.type.name === type) {
                  factor = volumeDisplayUnit.factor;
                  selectedSymbol = volumeDisplayUnit.selectedSymbol.name;
                }

                if (countDisplayUnit.type.name === type) {
                  factor = countDisplayUnit.factor;
                  selectedSymbol = countDisplayUnit.selectedSymbol.name;
                }

                if (angleDisplayUnit.type.name === type) {
                  factor = angleDisplayUnit.factor;
                  selectedSymbol = angleDisplayUnit.selectedSymbol.name;
                }

                const valueInDisplayUnits = ACTIONS.getDisplayQuantity({
                  quantity: alteredValue,
                  factor,
                }).quantity;
                const result = `${name}: ${ACTIONS.getEstimateNumberValueBasedOnSettings(
                  valueInDisplayUnits,
                  estimateData,
                  "measurement",
                )} ${selectedSymbol}`;

                return <ChipDirective key={`${args.id}_${index}`} text={result} />;
              })}
            </ChipsDirective>
          </ChipListComponent>,
        );
      }
    }
    return container;
  };

  const getMeasurementFromId = (id: any) => {
    const getAllMeasurements = viewerImpl?.hwv.measureManager.getAllMeasurements();
    return getAllMeasurements.find((record: any) => id == record.cubeUniqueId);
  };

  const handleSaveMeasurement = async (measurement: any, fetchData = true) => {
    if (TEMP_MARKUP_NAMES.has(measurement._name)) return;
    if (takeOffItemId) loadMarkupStyles(measurement, takeoffDataRef.current);
    await saveMeasurements(measurement, fetchData);
  };

  const viewerCallbacks = {
    measurementDeleted: () => {
      dispatch(updateMeasurementAttributePopup(false, null, null));
    },
    measurementCreated: async (measurement: any) => {
      if (!startStopRef.current) return;

      activateOperator(OperatorId.Select);
      await handleSaveMeasurement(measurement);
    },
    sheetDeactivated: () => {
      setCurrentSheetId(-1);
    },
    sheetActivated: (sheetId: any) => {
      setCurrentSheetId(sheetId);
    },
  };

  const measurementsCleanup = () => {
    if (startStopRef.current) {
      dispatch(setIsMeasurementStarted({ status: false }));
      quantityTakeoffToolbarVisibility(false);
      hideAllTools();
    }

    if (viewerImpl) {
      viewerImpl.activateOperator(OperatorId.Select);
      viewerImpl.unsetCallbacks(viewerCallbacks);
    }

    if (source === ACTIONS.measurementSources.MEASUREMENTS) {
      removeAllMarkupsFromViewer({ unmount: true });
      dispatch(ACTIONS.setMeasurements([]));
      dispatch(ACTIONS.setMeasurementsModalStatus({ status: false }));
      dispatch(setEstimateFieldsNeedtoRefresh(estimateFieldsNeedToRefreshIntialState));
    }

    setStartStop(false);
  };

  const shouldAttachViewerCallbacks =
    (source === ACTIONS.measurementSources.MEASUREMENTS || source === ACTIONS.measurementSources.TAKEOFFS) &&
    viewerImpl;

  useViewerCallbacks({
    viewerCallbacks: shouldAttachViewerCallbacks ? viewerCallbacks : null,
  });

  const componentMounted = async () => {
    if (
      source === ACTIONS.measurementSources.MEASUREMENTS &&
      ACTIONS.isEstimateRequiredPermission(estimateData, RESOURCE_VIEW.id)
    ) {
      setShowLoader(true);
      await fetchMeasurements();
      setShowLoader(false);
      dispatch(ACTIONS.setMeasurementsModalStatus({ status: true }));
    }
  };

  useEffect(() => {
    takeoffsModalStatusRef.current = HoopsModalStatus.Takeoffs;
  }, [HoopsModalStatus]);

  useEffect(() => {
    takeoffDataRef.current = takeoffData;
  }, [takeoffData]);

  useEffect(() => {
    startStopRef.current = startStop;
  }, [startStop]);

  useEffect(() => {
    measurementsModalStatusRef.current = measurementsModalStatus;
  }, [measurementsModalStatus]);

  useEffect(() => {
    activeDerivedMeasurementTabRef.current = activeDerivedMeasurementTab;
  }, [activeDerivedMeasurementTab]);

  const initMeasurementSelection = async () => {
    if (
      urlSearchParams.get("measurementId") &&
      source === ACTIONS.measurementSources.MEASUREMENTS &&
      ACTIONS.isEstimateRequiredPermission(estimateData, RESOURCE_VIEW.id)
    ) {
      const getParams = {
        value: {
          params: {
            estimateId,
            measurementId: urlSearchParams.get("measurementId") ?? undefined,
            fileVersionId,
            versionId: estimateVersionId ?? undefined,
          },
        },
      };
      const needToSelectMeasurmentData = await ACTIONS.getMeasurementsList(getParams);

      if (get(needToSelectMeasurmentData, "data.result.length") && needToSelectMeasurmentData.data.result) {
        const sheetId = (needToSelectMeasurmentData.data.result[0] as any).sheetId || -1;
        if (sheetId !== currentSheetIdRef.current) {
          if (sheetId === -1) {
            await viewerImpl.hwv.sheetManager.deactivateSheets();
          } else {
            await viewerImpl.hwv.sheetManager.setActiveSheetId(sheetId);
          }
        }
      } else {
        setCurrentSheetId(-1);
      }
    }
  };

  useEffect(() => {
    return measurementsCleanup;
  }, []);

  useEffect(() => {
    if (
      source === ACTIONS.measurementSources.MEASUREMENTS &&
      getIsViewerDependencyLoaded({ isModelStructureReady, isSettingsApplied, viewerImpl, hwv: CubeGlobal.hwv })
    ) {
      initMeasurementSelection();
    }
  }, [isSettingsApplied, isModelStructureReady]);

  useEffect(() => {
    currentSheetIdRef.current = currentSheetId;
    if (source == ACTIONS.measurementSources.MEASUREMENTS && currentSheetId !== null) {
      removeAllMarkupsFromViewer({ unmount: false });
      setItemsMarked([]);
      setEnableToolbarButtons(false);
      setShowTakeoffsList(false);
      isInitialMarkupLoadDone.current = false;
      componentMounted();
    }
  }, [currentSheetId]);

  useEffect(() => {
    if (
      source === ACTIONS.measurementSources.MEASUREMENTS &&
      getIsViewerDependencyLoaded({ isModelStructureReady, isSettingsApplied, viewerImpl, hwv: CubeGlobal.hwv }) &&
      ACTIONS.isEstimateRequiredPermission(estimateData, RESOURCE_VIEW.id)
    ) {
      measurementsListRef.current = [...measurementsList];
      if (measurementsList.length && !isInitialMarkupLoadDone.current) {
        removeAllMarkupsFromViewer({ unmount: false });
        loadAllMarkups();
        isInitialMarkupLoadDone.current = true;
      } else {
        const obj: any = {};
        setDisplayMeasurements((prev: any) => {
          for (const measurement of measurementsList) {
            const { measurementId } = measurement;
            if (measurementId != null) {
              if (Object.hasOwn(prev, measurementId)) {
                obj[measurementId] = prev[measurementId];
              } else {
                obj[measurementId] = true;
              }
            }
          }
          return obj;
        });
      }
    }
  }, [measurementsList, isModelStructureReady, isSettingsApplied]);

  useEffect(() => {
    if (source === ACTIONS.measurementSources.MEASUREMENTS && dataGrid.current) {
      dataGrid.current.dataset = measurementsList;
    }
  }, [measurementsList, dataGrid, source]);

  useEffect(() => {
    if (source === ACTIONS.measurementSources.MEASUREMENTS && estimateFieldsNeedToRefresh.measurements) {
      const setData = ACTIONS.prepareEstimationFieldNeedToRefresh({
        HoopsModalStatus,
        measurements: false,
        estimateFieldsNeedToRefresh,
      });
      dispatch(setEstimateFieldsNeedtoRefresh(setData));
    }
  }, [measurementsList, HoopsModalStatus, estimateFieldsNeedToRefresh, source]);

  useEffect(() => {
    if (source === ACTIONS.measurementSources.MEASUREMENTS && estimateFieldsNeedToRefresh.measurements) {
      fetchMeasurements();
    }
  }, [estimateFieldsNeedToRefresh, fetchMeasurements, source]);

  useEffect(() => {
    itemsMarkedRef.current = itemsMarked;
    if (itemsMarked.length !== 1) {
      setDerivedMeasurementOptions([]);
      setShowDeriveMeasurementsModal(false);
      return;
    }

    const derivedMeasurementTypes: any[] = [];
    const measurement = getMeasurementFromId(itemsMarked[0]);
    // 3D case
    if (measurement) {
      if (measurement.derivePerimeterMeasurement) derivedMeasurementTypes.push(typePerimeter);
      if (measurement.deriveSurfaceAreaMeasurement) derivedMeasurementTypes.push(typeSurfaceArea);
      if (measurement.deriveCircumferenceMeasurement) derivedMeasurementTypes.push(typeCircumference);
      if (measurement.deriveLengthSegmentsMeasurement) derivedMeasurementTypes.push(typeLengthSegments);
    }

    setDerivedMeasurementOptions(derivedMeasurementTypes);
  }, [itemsMarked]);

  useEffect(() => {
    if (source == ACTIONS.measurementSources.MEASUREMENTS) {
      displayMeasurementsRef.current = displayMeasurements;
    }
  }, [displayMeasurements, source]);

  const onTabSelect = (value: any) => {
    flagToCheckRowSelectionRef.current = true;
    setActiveDerivedMeasurementTab(value);
  };

  const getDeriveMeasurementGrid = useCallback(() => {
    return (
      <DeriveMeasurements
        key={activeDerivedMeasurementTab}
        dataSource={derivedMeasurementsRef.current.data[activeDerivedMeasurementTab!]}
        derivedMeasurementsSelectingEvents={derivedMeasurementsSelectingEvents}
        selectedMeasurements={derivedMeasurementsRef.current.selectedRecords[activeDerivedMeasurementTab!]}
      />
    );
  }, [activeDerivedMeasurementTab]);

  const getDeriveMeasurementsModal = () => (
    <div className="fixed inset-0 z-[2] w-screen h-screen bg-[var(--background-scrim)]">
      <div className="fixed top-[20%] start-[25%] z-[3] w-[43.75rem] rounded-md bg-white border border-[#ecf3fe] shadow-[0.25rem_0.5rem_0.5rem_0_rgb(0_0_0_/_15%)]">
        <div className="flex items-center justify-between flex-row bg-[#f6f9fc] pt-[1.125rem] pb-[1.125rem] pe-6 ps-10">
          <Text>{t("Derive Measurements")}</Text>
          <GrClose size="20" onClick={finishDeriveMeasurements} className="cursor-pointer" />
        </div>
        <div className="px-10 border-0 border-b border-button_light">
          <Box sx={{ paddingBottom: "0.1875rem" }}>
            <Tabs
              value={activeDerivedMeasurementTab}
              onChange={(event, selectedTab: any) => onTabSelect(selectedTab)}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                "& .MuiTabs-indicator": {
                  backgroundColor: "#6BBBE3",
                  height: "0.25rem",
                  borderRadius: "1.25rem",
                },
                "& .MuiTab-root": {
                  textTransform: "none",
                  fontSize: "1rem",
                  color: "#192048",
                  minWidth: "auto",
                  marginInlineEnd: "3rem",
                  padding: 0,
                },
                "& .Mui-selected": {
                  color: "#192048",
                  fontWeight: 600,
                },
              }}
            >
              {derivedMeasurementOptions.map(({ text, value }: any) => (
                <Tab label={text} value={value} key={value} />
              ))}
            </Tabs>
          </Box>
        </div>
        <div className="pt-2.5 pb-5 pe-6 ps-10">
          <div className="h-[12.5rem] overflow-auto">{getDeriveMeasurementGrid()}</div>
          <ButtonComponent
            buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
            onClick={(e: React.MouseEvent) => saveDerivedMeasurements(e)}
            disabled={!derivedMeasurementSelected}
          >
            <Text>{t("Create")}</Text>
          </ButtonComponent>
        </div>
      </div>
    </div>
  );

  const getTakeoffsListContainer = () => (
    <div className="flex flex-col absolute z-[10] bg-white shadow-[0_0.25rem_0.25rem_0_rgb(0_0_0_/_25%)] p-5 overflow-auto">
      {takeoffsList.length ? (
        <>
          <div className="h-[9.375rem] w-[12.5rem] overflow-auto">
            {takeoffsList.map((takeoff: any) => (
              <div key={takeoff.takeOffItemId} className="flex flex-row">
                <input
                  type="checkbox"
                  id={takeoff.takeOffItemId}
                  name={takeoff.takeOffItemId}
                  onClick={checkboxClicked}
                />
                <label className="ms-2.5" htmlFor={takeoff.takeOffItemId}>
                  {takeoff.name}
                </label>
              </div>
            ))}
          </div>
          <ButtonComponent
            buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
            onClick={attachMeasurementsToTakeoffs}
            disabled={!takeoffsChecked.length}
          >
            <Text>{t("Add")}</Text>
          </ButtonComponent>
        </>
      ) : (
        <small>
          <strong>
            <Text>{t("No more takeoffs available")}</Text>
          </strong>
        </small>
      )}
      <ButtonComponent buttonType={BUTTON_TYPES.BACKGROUND_BUTTON} onClick={startNewTakeoff} className="mt-2.5">
        <Text>{t("Create New Takeoff")}</Text>
      </ButtonComponent>
    </div>
  );

  const getNestedMeasurements = (cubeUniqueId: any) => {
    if (viewerImpl.hwv) {
      const allMeasurements = viewerImpl.hwv.measureManager.getAllMeasurements();
      const selectedMeasurement = allMeasurements.find((record: any) => record.cubeUniqueId === cubeUniqueId);

      if (get(selectedMeasurement, "getNestedMeasurements")) {
        const nestedMeasurements = selectedMeasurement.getNestedMeasurements();
        return nestedMeasurements;
      }
    }

    return [];
  };

  const measurementTypeTemplate = (data: any, value: any, a: any, b: any, params: any) => {
    if (params.__isDummy) {
      return "";
    } else {
      if (params.markup == "{}" && params.elements) {
        return "3D";
      }
      return get(params, "unit.type.name");
    }
  };

  const nameEditTemplate = () => (
    <TextFieldComponent
      onChange={(e) => setEditingRowValue((prev: any) => ({ ...prev, name: e.target.value }))}
      defaultValue={editingRowValue["name"]}
    />
  );

  const multiplierEditTemplate = () => (
    <TextFieldComponent
      onChange={(e) => setEditingRowValue((prev: any) => ({ ...prev, multiplier: e.target.value }))}
      type="number"
      defaultValue={editingRowValue["multiplier"]}
    />
  );

  const gridColumns = useMemo(
    () =>
      getMeasurementsListColumns({
        source,
        nameTemplate,
        hightlightMeasurementTemplate,
        tagsTemplate,
        eyeIconHeaderTemplate,
        eyeIconTemplate,
        isFilterAllowed,
        measurementTemplate,
        measurementTypeTemplate,
        takeOffsTemplate,
        nestedMeasurementTemplate,
        measuredValueTemplate,
        unitsTemplate,
        nameEditTemplate,
        multiplierEditTemplate,
      }),

    [editingRowValue.measurementId, displayMeasurements, isSettingsApplied, isModelStructureReady],
  );

  const getRowHeight = () => (source === ACTIONS.measurementSources.ESTIMATE ? 60 : 40);

  const getDataGrid = () =>
    gridColumns && (
      <div className="flex overflow-auto h-full w-full">
        <SlickGrid1
          ref={dataGrid}
          enableWrapText={true}
          enableSelectAllCheckbox={true}
          showLoader={showLoader}
          showPageCount={
            ![ACTIONS.measurementSources.TAKEOFF_SIDEBAR, ACTIONS.measurementSources.TAKEOFFS].includes(source)
          }
          columnDefinitions={gridColumns as any}
          rowHeight={getRowHeight()}
          disableCheckBoxSelection={
            ![
              ACTIONS.measurementSources.MEASUREMENTS,
              ACTIONS.measurementSources.TAKEOFFS,
              ACTIONS.measurementSources.REFERENCE_MEASUREMENT,
            ].includes(source) || !!estimateVersionId
          }
          enableSortingOption
          enableFilteringOption
          onSelectedRowIdsChanged={selectingEvents}
          dataset={source == ACTIONS.measurementSources.MEASUREMENTS ? measurementsList : undefined}
          remoteDataSource={source !== ACTIONS.measurementSources.MEASUREMENTS ? estimateMeasurementsUrl : undefined}
          infiniteScroll
          query={gridQuery as any}
          setGridReady={dataBound}
          onClick={recordClick}
          isEditMode={!!editingRowValue.measurementId}
          toolbar={getMeasurementToolbarItems()}
          toolbarClickHandler={measurementToolbarClickHandler}
        />
      </div>
    );

  const handleModifyNestedMeasurement = () => {
    const selectedRecord = dataGrid.current.slickGrid
      .getSelectedRows()
      .map((data: any) => dataGrid.current.slickGrid.getDataItem(data))[0];
    let nestedMeasurements;

    if (selectedRecord.nestedMeasurements == null) {
      nestedMeasurements = {
        data: getNestedMeasurements(selectedRecord.id).map((measurement: any, index: number) => ({
          originalValue: measurement.value,
          alteredValue: measurement.value,
          type: measurement.type.value,
          name: measurement.name === "" ? `Measurement ${index + 1}` : measurement.name,
        })),
        total: {
          originalValue: selectedRecord.quantity * selectedRecord.multiplier,
          alteredValue: selectedRecord.quantity * selectedRecord.multiplier,
          type: selectedRecord.type,
          name: "Measurement",
        },
      };
    } else {
      nestedMeasurements = JSON.parse(selectedRecord.nestedMeasurements);
    }

    dispatch(
      setSelectedNestedMeasurements({
        ...selectedRecord,
        nestedMeasurements,
      }),
    );

    if (!get(HoopsModalStatus, "NestedMeasurements.show")) {
      dispatch(
        setModalStatus({
          ...HoopsModalStatus,
          NestedMeasurements: {
            show: true,
          },
        }),
      );
    }
  };

  const handleAddCustomMeasurement = (data?: any) => {
    setManualMeasurementModal((prev) => ({ ...prev, show: true, data }));
  };

  const handleCloseManualMeasurement = () => {
    setManualMeasurementModal({ show: false, data: null });
  };

  const handleCreateManualMeasurement = async (manualData: any, measurementData: any) => {
    if (
      !manualData.name ||
      !manualData.type ||
      !Number.isFinite(manualData.value) ||
      !manualData.unit ||
      (manualData.isReferenced && manualData.references.length < 1)
    ) {
      dispatch(
        showToastNotification({
          content: t("Please fill all details."),
          type: TOAST_TYPE_ERROR,
        }),
      );
    } else {
      const { linearDisplayUnit, areaDisplayUnit, volumeDisplayUnit, countDisplayUnit } =
        estimateData as EstimateDataWithDisplayUnits;

      for (const displayUnit of [linearDisplayUnit, areaDisplayUnit, volumeDisplayUnit, countDisplayUnit]) {
        if (displayUnit.type.name === manualData.type && displayUnit.id !== manualData.unit) {
          dispatch(
            showToastNotification({
              content: t("Value and units changed to match estimate's display units."),
              type: TOAST_TYPE_NORMAL,
            }),
          );
        }
      }

      if (get(measurementData, "measurementId")) {
        await ACTIONS.updateMeasurement({
          measurementId: measurementData.measurementId,
          name: manualData.name,
          type: manualData.type,
          quantity: manualData.value,
          manualUnit: manualData.unit,
          referenceMeasurements: manualData.references,
          formula: manualData.formula,
          estimateId,
        });
      } else {
        await ACTIONS.createMeasurement({
          measurementId: createUuid(),
          name: manualData.name,
          type: manualData.type,
          quantity: manualData.value,
          manualUnit: manualData.unit,
          referenceMeasurements: manualData.references,
          formula: manualData.formula,
          scale: "1:1",
          markup: "{}",
          fileVersionId,
          estimateId,
          isManualMeasurement: true,
          sheetId: currentSheetIdRef.current,
        });
      }

      handleCloseManualMeasurement();
      reloadMeasurements(true);
    }
  };

  const getErrorMessageforSelectedMeasurement = () => {
    if (
      measurementsList
        .filter((measurement: any) => measurement.nature !== "Static")
        .map((val: any) => val.measurementId)
        .some((item: any) => itemsMarked.includes(item))
    ) {
      return t("Only Static Measurements can be added to Takeoffs");
    }
    if (
      new Set(
        measurementsList
          .filter((item: any) => itemsMarked.includes(item.measurementId))
          .map((val: any) => val.unit.type.id),
      ).size !== 1
    ) {
      return t("Only Measurements with similar Type can be added to Takeoffs");
    }
    return "";
  };

  const checkSystemGeneratedMeasurementSelected = () => {
    return measurementsList.some(
      (measurement: any) => measurement.isSystemGenerated && itemsMarked.includes(measurement.measurementId),
    );
  };

  const editClickHandler = () => {
    const selectedRecord = measurementsList.find((item: any) =>
      itemsMarked.includes(item.measurementId),
    ) as MeasurementRow;
    if (selectedRecord.isManualMeasurement) {
      handleManualMeasurementEdit(measurementsList.find((item: any) => itemsMarked.includes(item.measurementId)));
    } else {
      setEditingRowValue({
        measurementId: selectedRecord.measurementId,
        name: selectedRecord.name,
        multiplier: selectedRecord.multiplier,
        takeOffs: selectedRecord.takeOffs,
      });
    }
  };

  const cancelEditMeasurement = () => {
    setEditingRowValue({});
  };

  const saveClickHandler = async () => {
    setButtonLoading(true);
    await ACTIONS.updateMeasurement({
      measurementId: editingRowValue.measurementId,
      name: editingRowValue.name,
      multiplier: Number.isNaN(Number.parseFloat(editingRowValue.multiplier))
        ? 1
        : Number.parseFloat(editingRowValue.multiplier),
      estimateId,
    });
    reloadMeasurements(true);

    if (editingRowValue.takeOffs?.length) {
      const setData = ACTIONS.prepareEstimationFieldNeedToRefresh({
        HoopsModalStatus,
        takeoffs: editingRowValue.takeOffs.map((takeoff: any) => takeoff.takeOffItemId),
        estimateFieldsNeedToRefresh,
      });
      dispatch(setEstimateFieldsNeedtoRefresh(setData));
    }
    setButtonLoading(false);
    cancelEditMeasurement();
  };

  const stopMeasurementHandler = () => {
    if (startStop) {
      startStopMeasurement();
    } else {
      handleCloseManualMeasurement();
    }
  };

  const handleDropDownSelectionHandler = (args: any) => {
    const buttonClicked = args.item.id;
    if (buttonClicked === "standard") {
      startStopMeasurement();
    } else if (buttonClicked == "manual") {
      handleAddCustomMeasurement();
    }
  };

  const dropDownButtonItems = () => [
    {
      id: "standard",
      text: "Start Measuring",
      disabled: !getIsViewerDependencyLoaded({
        isModelStructureReady,
        isSettingsApplied,
        viewerImpl,
        hwv: CubeGlobal.hwv,
      }),
    },
    { id: "manual", text: "Create Manual Measurement", enabled: false },
  ];

  const getDeleteButtonText = () => (source === ACTIONS.measurementSources.TAKEOFFS ? t("Remove") : t("Delete"));

  const isVersionMode = !!estimateVersionId;
  const isSystemGenerated = checkSystemGeneratedMeasurementSelected();
  const commonDisabled = isVersionMode || !actionPermissionAllowed || isSystemGenerated;

  const startMeasurementTemplate = () => {
    if (startStop || manualMeasurementModal.show) {
      return (
        <ButtonComponent
          disabled={
            isVersionMode ||
            !getIsViewerDependencyLoaded({
              isModelStructureReady,
              isSettingsApplied,
              viewerImpl,
              hwv: CubeGlobal.hwv,
            }) ||
            !actionPermissionAllowed
          }
          onClick={stopMeasurementHandler}
          buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
        >
          <div className="flex gap-2 items-center">
            <IconComponent name="Pause" width="1rem" height="1rem" />
            <Text>{t("Stop")}</Text>
          </div>
        </ButtonComponent>
      );
    }
    return (
      <SelectDropDown
        select={handleDropDownSelectionHandler}
        items={dropDownButtonItems()}
        disabled={
          isVersionMode ||
          !getIsViewerDependencyLoaded({ isModelStructureReady, isSettingsApplied, viewerImpl, hwv: CubeGlobal.hwv }) ||
          !actionPermissionAllowed
        }
        allowButtonPadding={false}
        cssClass="border-none"
        buttonType="dropdownBackgroundButton"
      >
        <ButtonComponent buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}>
          <span className="inline-block">
            <div className="flex gap-2 items-center">
              <IconComponent name="Start" width="0.75rem" height="0.75rem" />
              <Text>{t("Start")}</Text>
            </div>
          </span>
        </ButtonComponent>
      </SelectDropDown>
    );
  };

  const addToTakeoffsTemplate = () => {
    const errorMessage = getErrorMessageforSelectedMeasurement();
    const button = (
      <ButtonComponent
        buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
        disabled={!actionPermissionAllowed || !!estimateVersionId || !!errorMessage || isSystemGenerated}
        onClick={addToTakeoffsClickHandler}
      >
        <Text>{t("Add to takeoffs")}</Text>
      </ButtonComponent>
    );
    return (
      <div>
        {errorMessage ? (
          <ToolTipComponent position="bottom" content={errorMessage}>
            {button}
          </ToolTipComponent>
        ) : (
          button
        )}
        {showTakeoffsList && getTakeoffsListContainer()}
      </div>
    );
  };

  const isMeasurementSource = source === ACTIONS.measurementSources.MEASUREMENTS;
  const isTakeoffSource = source === ACTIONS.measurementSources.TAKEOFFS;

  const getMeasurementToolbarItems = () => {
    if (openAsPopup) return [];
    if (editingRowValue.measurementId) {
      return [
        {
          id: MEASUREMENT_TOOLBAR_IDS.SAVE,
          name: t("Save"),
          prefixIcon: "Update",
          disabled: buttonLoading,
        },
        {
          id: MEASUREMENT_TOOLBAR_IDS.CANCEL,
          name: t("Cancel"),
          prefixIcon: "close",
          disabled: buttonLoading,
        },
      ];
    }

    const items: any[] = [];

    if (isMeasurementSource) {
      items.push({
        id: MEASUREMENT_TOOLBAR_IDS.START,
        template: startMeasurementTemplate,
      });
    }

    if (isMeasurementSource && enableToolbarButtons && itemsMarked.length === 1) {
      items.push({
        id: MEASUREMENT_TOOLBAR_IDS.EDIT,
        name: t("Edit"),
        prefixIcon: "edit",
        disabled: commonDisabled,
      });
    }

    if ((isMeasurementSource || (isTakeoffSource && takeOffIncludedMeasuremnt)) && enableToolbarButtons) {
      items.push({
        id: MEASUREMENT_TOOLBAR_IDS.DELETE,
        name: getDeleteButtonText(),
        disabled: commonDisabled,
      });
    }

    if (isMeasurementSource && enableToolbarButtons && itemsMarked.length > 0) {
      items.push({
        id: MEASUREMENT_TOOLBAR_IDS.ADD_TO_TAKEOFFS,
        template: addToTakeoffsTemplate,
      });
    }

    if (isMeasurementSource && enableToolbarButtons && itemsMarked.length === 1) {
      items.push({
        id: MEASUREMENT_TOOLBAR_IDS.DUPLICATE,
        name: t("Duplicate"),
        disabled:
          !!estimateVersionId ||
          !actionPermissionAllowed ||
          isSystemGenerated ||
          (measurementsList as MeasurementRow[]).find((measurement: any) => measurement.measurementId == itemsMarked[0])
            ?.nature !== "Static",
      });

      items.push({
        id: MEASUREMENT_TOOLBAR_IDS.DERIVE,
        name: t("Derive"),
        disabled:
          !derivedMeasurementOptions.length ||
          !actionPermissionAllowed ||
          startStop ||
          isSystemGenerated ||
          isVersionMode,
      });

      items.push({
        id: MEASUREMENT_TOOLBAR_IDS.SITE_MEASUREMENT,
        name: t("Site Measurement"),
        disabled: commonDisabled,
      });
    }

    return items;
  };

  const measurementToolbarClickHandler = (toolClicked: string) => {
    switch (toolClicked) {
      case MEASUREMENT_TOOLBAR_IDS.EDIT:
        editClickHandler();
        break;
      case MEASUREMENT_TOOLBAR_IDS.DELETE:
        destroyMeasurement();
        break;
      case MEASUREMENT_TOOLBAR_IDS.DUPLICATE:
        duplicateMeasurementClickHandler();
        break;
      case MEASUREMENT_TOOLBAR_IDS.DERIVE:
        beginDeriveMeasurements();
        break;
      case MEASUREMENT_TOOLBAR_IDS.SITE_MEASUREMENT:
        handleModifyNestedMeasurement();
        break;
      case MEASUREMENT_TOOLBAR_IDS.SAVE:
        saveClickHandler();
        break;
      case MEASUREMENT_TOOLBAR_IDS.CANCEL:
        cancelEditMeasurement();
        break;
      default:
        break;
    }
  };

  return estimateError ? (
    <EstimateNotFoundPage projectId={urlSearchParams.get("projectId")!} />
  ) : (
    <div
      className={
        source === ACTIONS.measurementSources.MEASUREMENTS
          ? "h-full flex flex-col px-5"
          : "flex-grow h-full overflow-auto flex flex-col"
      }
    >
      {(source === ACTIONS.measurementSources.MEASUREMENTS || source === ACTIONS.measurementSources.TAKEOFFS) &&
        showCalibrationModal && (
          <CalibrationModal viewerImpl={viewerImpl} handleCalibrationModal={handleCalibrationModal} />
        )}

      {source === ACTIONS.measurementSources.MEASUREMENTS && showNewTakeoffModal && (
        <CreateNewTakeoffModal estimateId={estimateId} closeTakeoffModal={closeTakeoffModal} />
      )}

      {showDeriveMeasurementsModal && getDeriveMeasurementsModal()}

      <div className="h-full overflow-auto" id="measurements_grid_unique">
        {getDataGrid()}
      </div>

      {duplicateModalAndData.show && (
        <DuplicateTakeoffModal
          closeDuplicateTakeoffModal={closeDuplicateMeasurementModal}
          copyTakeoff={copyMeasurement}
          isDuplicateMeasurement
        />
      )}

      {manualMeasurementModal.show && (
        <ManualMeasurement
          measurementData={manualMeasurementModal.data ?? undefined}
          handleCloseManualMeasurement={handleCloseManualMeasurement}
          estimateId={estimateId}
          handleCreateManualMeasurement={handleCreateManualMeasurement}
          fileVersionId={fileVersionId}
        />
      )}
    </div>
  );
});

Measurements.displayName = "Measurements";
export default Measurements;
